import { twMerge } from "tailwind-merge";
import { motion } from "framer-motion";

export type Props = {
  /** Content to animate */
  children: React.ReactNode;
  /** Additional CSS classes */
  className?: string;
};

/**
 * A slide-left animation wrapper using framer-motion.
 */
export function MotionSlideLeft({ children, className, ...props }: Props) {
  return (
    <motion.div
      initial={{ x: "100%" }}
      animate={{ x: 0 }}
      exit={{ x: "100%" }}
      transition={{ duration: 0.1, ease: "linear" }}
      className={twMerge("", className)}
      data-testid="motion-slide-left"
      {...props}
    >
      {children}
    </motion.div>
  );
}

export default MotionSlideLeft;

